module.exports = __webpack_public_path__ + "assets/images/7ccfe1cd641703445687b9122869d608.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/portfolio/reserve-web/reserve-web-2.jpg
// module id = 792
// module chunks = 0